// ============================================================================
// CHARGE TYPE HOOKS
// ============================================================================
// React hook for the ChargeType read-only lookup.

import { useState, useEffect, useCallback } from 'react';
import { chargeTypeService } from 'api/services/chargeTypeService';
import type { ChargeType } from 'api/types';

/**
 * Hook to fetch all charge types (small lookup — 4 rows).
 * Fetches once on mount. Call `refetch()` to reload.
 */
export const useChargeTypes = () => {
  const [data, setData] = useState<ChargeType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchChargeTypes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await chargeTypeService.getAll();
      setData(response.data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchChargeTypes();
  }, [fetchChargeTypes]);

  return { data, loading, error, refetch: fetchChargeTypes };
};
